import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserRole, UserStatus } from 'src/app/core/models/auth.models';
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserServiceService {
  handleError: any;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient,
    protected authSrv: AuthenticationService,
    protected translate: TranslateService) {
  }

  getUsers(pageSize: number, page: number, search?: string, filter?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'photo,company,company.accountManager',
      pageSize,
      page,
    });

    if (this.translate.currentLang === 'pt') {
      params = params.append('sort', 'firstName:ASC,lastName:ASC');
    } else params = params.append('sort', 'lastName:ASC,firstName:ASC');

    if (this.authSrv.currentUser) params = params.append('queryNot[id]', this.authSrv.currentUser.id);

    if (search) params = params.appendAll({
      searchFields: `firstName,lastName,email,company.name`,
      search
    });

    if (filter) {
      if (filter.role && filter.role !== '') params = params.append('query[role]', filter.role);
      if (filter.status && filter.status !== '') params = params.append('query[status]', filter.status);
      if (filter.partner && filter.partner !== '') params = params.append('query[company.partnerId]', filter.partner);
    }

    if (!filter || !filter.status || filter.status && filter.status === '') params = params.append('queryNot[status]', UserStatus.PENDING);

    return this.http.get<any>(environment.API_URL + `/api/users`, { params });
  }

  getPartnerUsers(pageSize: number, page: number, search?: string, filter?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'photo,company,company.accountManager',
      pageSize,
      page,
      'query[role]': UserRole.PARTNER
    });

    if (this.translate.currentLang === 'pt') {
      params = params.append('sort', 'firstName:ASC,lastName:ASC');
    } else params = params.append('sort', 'lastName:ASC,firstName:ASC');

    if (search) params = params.appendAll({
      searchFields: `firstName,lastName,email,company.name`,
      search
    });

    if (filter) {
      if (filter.role && filter.role !== '') params = params.append('query[role]', filter.role);
      if (filter.status && filter.status !== '') params = params.append('query[status]', filter.status);
      if (filter.partner && filter.partner !== '') params = params.append('query[company.partnerId]', filter.partner);
    }

    if (!filter || !filter.status || filter.status && filter.status === '') params = params.append('queryNot[status]', UserStatus.PENDING);

    return this.http.get<any>(environment.API_URL + `/api/users`, { params });
  }

  getPartnerClients(pageSize: number, page: number, search?: string, filter?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'photo,company,company.accountManager',
      pageSize,
      page,
      'query[role]': UserRole.CUSTOMER,
    });

    if (this.translate.currentLang === 'pt') {
      params = params.append('sort', 'firstName:ASC,lastName:ASC');
    } else params = params.append('sort', 'lastName:ASC,firstName:ASC');

    if (search) params = params.appendAll({
      searchFields: `firstName,lastName,email,company.name`,
      search
    });

    if (filter) {
      if (filter.role && filter.role !== '') params = params.append('query[role]', filter.role);
      if (filter.status && filter.status !== '') params = params.append('query[status]', filter.status);
      if (filter.partner && filter.partner !== '') params = params.append('query[company.partnerId]', filter.partner);
    }

    if (!filter || !filter.status || filter.status && filter.status === '') params = params.append('queryNot[status]', UserStatus.PENDING);

    return this.http.get<any>(environment.API_URL + `/api/users`, { params });
  }

  getUser(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/users/${id}?relations=photo`);
  }
  getSimpleUser(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/users/${id}`);
  }
  revalidateEmail(id: number) {
    return this.http.post<any>(environment.API_URL + `/api/users/${id}/sendEmail`, {}, { headers: this.headers });
  }

  getCompanyUser(id: number) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'photo,company,company.logo,company.partner'
    });
    return this.http.get<any>(environment.API_URL + `/api/users/${id}`, { params });
  }
  getCompanyUserInfo(idC: number, idU: number) {
    return this.http.get<any>(environment.API_URL + `/api/companies/${idC}/users/${idU}?relations=photo,company`);
  }

  getCompanyInfo(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/companies/${id}/summary`);
  }

  getCompany(companyId: number) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'logo,accountManager,partner',
    });

    return this.http.get<any>(environment.API_URL + `/api/companies/${companyId}`, { params });
  }

  getPendentUsers(pageSize: number, page: number, search?: string, filter?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'photo,company,company.accountManager',
      pageSize,
      page,
      'query[status]': UserStatus.PENDING
    });

    if (this.translate.currentLang === 'pt') {
      params = params.append('sort', 'firstName:ASC,lastName:ASC');
    } else params = params.append('sort', 'lastName:ASC,firstName:ASC');

    if (search) params = params.appendAll({
      searchFields: `firstName,lastName,email`,
      search
    });

    if (filter) {
      if (filter.role && filter.role !== '') params = params.append('query[role]', filter.role);
      if (filter.partner && filter.partner !== '') params = params.append('query[company.partnerId]', filter.partner);
    }

    return this.http.get<any>(environment.API_URL + `/api/users`, { params });
  }

  updateUser(user: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/users/${id}`, user, { headers: this.headers })
  }
  // updateUserCompany(guest: any, id: number): any {
  //   return this.http.patch<any>(environment.API_URL + `/api/users/${id}/updateUserCompany`, guest, { headers: this.headers })
  // }
  setActive(id: number): any {
    return this.http.get<any>(environment.API_URL + `/api/users/${id}/setUserAsActive`, { headers: this.headers })
  }

  updateUserPassword(user: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/users/${id}/changePassword`, user, { headers: this.headers })
  }

  updateCompany(company: any, id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/companies/${id}`, company, { headers: this.headers })
  }

  deleteUser(id: number) {
    return this.http.delete(environment.API_URL + `/api/users/${id}`)
  }

  updateStatus(id: number, status: UserStatus) {
    return this.http.patch(environment.API_URL + `/api/users/${id}/status`, { status });
  }

  createUser(user: any): any {
    return this.http.post<any>(environment.API_URL + '/api/users', user, { headers: this.headers })
  }

  createCompany(company: any): any {
    return this.http.post<any>(environment.API_URL + '/api/companies', company, { headers: this.headers })
  }
  createUserCompany(data: any): any {
    return this.http.post<any>(environment.API_URL + '/api/users/newUserCompany', data, { headers: this.headers })
  }

  deleteCompany(id: number): any {
    return this.http.delete<any>(environment.API_URL + `/api/companies/${id}`)
  }

  activateCompany(id: number): any {
    return this.http.patch<any>(environment.API_URL + `/api/companies/${id}/active`, {})
  }

  getMembros(search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize: 7,
      page: 1,
      'query[status]': UserStatus.ACTIVE,
      'query[role]': UserRole.MEMBER
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'firstName,lastName,email',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/users`, { params });
  }

  getMembrosAndAdmins(search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize: 7,
      page: 1,
      // 'query[status]': UserStatus.ACTIVE,
      // 'query[role]': UserRole.MEMBER
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'firstName,lastName,email',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/users/adminMember`, { params });
  }

  getUsersDrop(search: any) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize: 7,
      page: 1,
      'query[status]': 'ACTIVE'
    });

    if (this.translate.currentLang === 'pt') {
      params = params.append('sort', 'firstName:ASC,lastName:ASC');
    } else params = params.append('sort', 'lastName:ASC,firstName:ASC');

    if (search) params = params.appendAll({
      searchFields: `firstName,lastName,email`,
      search
    });

    return this.http.get<any>(environment.API_URL + `/api/users`, { params });
  }

  getMembro(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/users/${id}`);
  }

  getAllUsers(page: number, pageSize: number, search?: string, currentId?: number) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      'query[status]': 'ACTIVE',
    });
    if (currentId) {
      params = params.append('queryNot[id]', currentId);
    }
    if (this.translate.currentLang === 'pt') {
      params = params.append('sort', 'firstName:ASC,lastName:ASC');
    } else params = params.append('sort', 'lastName:ASC,firstName:ASC');

    if (search) params = params.appendAll({
      searchFields: `firstName,lastName`,
      search
    });

    return this.http.get<any>(environment.API_URL + `/api/users`, { params });
  }

  findUsersWithoutColaborators() {
    return this.http.get<any>(environment.API_URL + `/api/users/without-colaborators`);
  }
}
